module.exports = __webpack_public_path__ + "img/basket.2e39eeed.svg";